module.exports = __webpack_public_path__ + "static/media/icon_confidence.97e95218.svg";